module.exports = {"532628101":"新华镇","532628102":"归朝镇","532628103":"剥隘镇","532628104":"里达镇","532628105":"田蓬镇","532628106":"木央镇","532628201":"板仑乡","532628202":"谷拉乡","532628203":"者桑乡","532628204":"那能乡","532628205":"洞波瑶族乡","532628206":"阿用乡","532628207":"花甲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532628.json
// module id = 2453
// module chunks = 0